import { setAutoDisburseOptIn } from '@api/useQueryCalls';
import { artWithdrawAll } from '@assets/png/imagesPng';
import DescriptionRow from '@atoms/DescriptionRow';
import LocalImage from '@atoms/LocalImage';
import { Button, Divider, Text, Checkbox } from '@components/primitives';
import { useToast } from '@hooks';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { id } from '@root/i18n/supportedLanguages';
import { ToastType } from '@root/types';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { showSuccessToast } from '@utils/toastManager';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, View } from 'react-native';
import { logAutoDTerms, logBackButtonTerms, logChangeBox, logContinue } from './analyticsTerms';
import styles from './style';

export function onSucccessHandler(navigation: NavigationProp<any>, toast: ToastType, t: (key: string) => string) {
  return () => {
    navigation.goBack();
    showSuccessToast(toast, t('autoDisburse.successOptIn'), 'autoDisburse');
  };
}

const GGAutoDisburseTerms = () => {
  const [acceptTerms, setAcceptTerms] = useState(false);
  const { t } = useTranslation('common');
  const navigation = useNavigation();
  const toast = useToast();

  const { mutate: setOptIn, isLoading: loading } = setAutoDisburseOptIn({
    onSuccess: onSucccessHandler(navigation, toast, t),
  });

  const onSetInHandler = () => {
    logContinue();
    setOptIn();
  };

  const shouldRenderDescription = (title: string, srNo: number, style?: object) => (
    <View style={[styles.descContainerAdj, style]}>
      <Text variant="md-normal" color={colors.neutral.darkMist} style={styles.srnoStyle}>
        {srNo}.
      </Text>
      <Text variant="md-normal" color={colors.neutral.darkMist} style={styles.descTitleStyle}>
        {title}
      </Text>
    </View>
  );

  useEffect(() => {
    logAutoDTerms();
    return () => {
      logBackButtonTerms();
    };
  }, []);

  return (
    <>
      <ScrollView style={styles.containerStyle} contentContainerStyle={styles.contentContainerStyle}>
        <View style={styles.imageContainer}>
          <LocalImage source={artWithdrawAll} style={styles.imageStyle} contentFit="contain" />
        </View>
        <Text variant="lg-bold" style={styles.titleStyle}>
          {t('autoDisburse.mainTitle')}
        </Text>

        {shouldRenderDescription(t('autoDisburse.descOne'), 1, styles.firstDescStyle)}
        {shouldRenderDescription(t('autoDisburse.descTwo'), 2)}

        <Divider style={styles.dividerStyle} />

        <Text variant="lg-bold" style={styles.bulletTitle}>
          {t('autoDisburse.bulletOne')}
        </Text>

        {Array.isArray(t('autoDisburse.terms', { returnObjects: true })) &&
          t('autoDisburse.terms', { returnObjects: true }).map((desc: string, i: number) => (
            <DescriptionRow key={`${desc}-${i}`} desc={desc} />
          ))}

        {id.autoDisburse.terms.map((d, i) => (
          <DescriptionRow key={d.substring(0, 5)} desc={t(`autoDisburse.terms.${i}`)} />
        ))}
      </ScrollView>

      <View style={styles.footerContainer}>
        <View style={styles.checkBoxRow}>
          <Checkbox
            testID="autoDisburseCheckbox"
            isChecked={acceptTerms}
            color={colors.primary.carnation}
            onChange={() => {
              logChangeBox();
              setAcceptTerms(prevState => !prevState);
            }}
          />
          <Text testID="checkboxTitle" variant="sm-bold" style={styles.checkBoxTextStyle}>
            {t('autoDisburse.termsTitle')}
          </Text>
        </View>

        <Button
          isLoading={loading}
          isDisabled={!acceptTerms || loading}
          textAlign="center"
          testID="btnAutoDisburse"
          sentry-label="btnOTP"
          paddingY={scale(8)}
          onPress={onSetInHandler}>
          {t('autoDisburse.continue')}
        </Button>
      </View>
    </>
  );
};

export default GGAutoDisburseTerms;
